import React from 'react';

import { PortalPlace } from '@interlayer/js/app/components/system/Portal/components/PortalPlace';

import { ID_RETAIL_REG_HEADER } from './constants';

import style from './RetailRegHeader.scss';

export const RetailRegHeader: React.FC = () => {
    return (
        <div className={style.container}>
            <div className={style.line} />

            <PortalPlace
                isHideAdminPanel
                id={ID_RETAIL_REG_HEADER}
            />
        </div>
    );
};
